async function dhlJsonFormsRenderers() {
  const [loader, jsonFormsRenderers] = await Promise.all([
    import('@dhl-official/stencil-library/loader'),
    import('./renderers'),
  ]);
  loader.defineCustomElements(window);

  return jsonFormsRenderers.default;
}

export default dhlJsonFormsRenderers;
